"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MovePage = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var MovePage = function MovePage() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 5.996H8.997a.5.5 0 01-.35-.85l3.002-3.002a.51.51 0 01.71 0l3.002 3.002a.5.5 0 01-.36.85H13v2.502a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5V5.996zM8.997 12.5v-1a.5.5 0 00-.5-.5H5.996V8.997a.5.5 0 00-.85-.36L2.144 11.64a.51.51 0 000 .71l3.002 3.002a.5.5 0 00.85-.35V13h2.502a.5.5 0 00.5-.5zm6.004 5.504H13v-2.502a.5.5 0 00-.5-.5H11.5a.5.5 0 00-.5.5v2.502H8.997a.5.5 0 00-.35.85l3.002 3.002a.51.51 0 00.71 0l3.002-3.002a.5.5 0 00-.36-.85zm3.862-9.356l3.002 3.002a.51.51 0 01-.01.7l-3.002 3.002a.5.5 0 01-.85-.35V13h-2.502a.5.5 0 01-.5-.5V11.5a.5.5 0 01.5-.5h2.502V8.997a.5.5 0 01.86-.35z",
    clipRule: "evenodd"
  });
};

exports.MovePage = MovePage;